
import Parser from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MdCheck } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';
import Button from '../../Component/Button/Button';
import Captcha from '../../Component/Captcha';
import Checkbox from '../../Component/Checkbox/Checkbox';
import CustomPhoneInput from '../../Component/CustomPhoneInput';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import HeroSection from '../../Component/HeroSection';
import Input from '../../Component/Input/Input';
import { Loader } from '../../Component/Loader';
import PackageCard from '../../Component/PackageCard';
import { imageUrl } from '../../config/apiUrl';
import {
  KeepInTouchIcon1,
  KeepInTouchIcon2,
  KeepInTouchIcon3,
  KeepInTouchIcon4,
  KeepInTouchIcon5,
  KeepInTouchSectionImage
} from '../../constant/imagePath';
import ThankYouModal from '../../modals/ThankYouModal/ThankYouModal';
import { useLazyGetApiQuery, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { getSelectedLanguagePage } from '../../utils/helpers';
import classes from './AgentRegisterationForm.module.css';
import PropTypes from 'prop-types';

const RegisterationForm = ({ t, onSubmit, isSubmitting, data }) => {
  const [formStates, setFormStates] = useState({
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    allowTerms: false
  });
  const [isCaptcha, setIsCaptcha] = useState(false);
  

  function handleFormStateUpdate(key, value) {
    setFormStates({ ...formStates, [key]: value });
  }

  return (
    <form
      className={classes.form}
      onSubmit={(e) => {




                                    e?.preventDefault();
      }}>
      <Row className={classes.formRow}>
        <Col md={12}>
          <h4>
         
            {data?.formTitle}
          </h4>
          <h6>
         
            {data?.formDescription}
          </h6>
        </Col>
        <Col md={12}>
          <Input
            value={formStates?.companyName}
            setValue={(e) => handleFormStateUpdate('companyName', e)}
            label={t('form.companyName')}
            placeholder={t('form.companyNamePlaceholder')}
          />
        </Col>
        <Col md={6}>
          <Input
            value={formStates?.firstName}
            setValue={(e) => handleFormStateUpdate('firstName', e)}
            label={t('form.firstName')}
            placeholder={t('form.firstNamePlaceholder')}
          />
        </Col>
        <Col md={6}>
          <Input
            value={formStates?.lastName}
            setValue={(e) => handleFormStateUpdate('lastName', e)}
            label={t('form.lastName')}
            placeholder={t('form.lastNamePlaceholder')}
          />
        </Col>
        <Col md={12}>
          <Input
            value={formStates?.email}
            setValue={(e) => handleFormStateUpdate('email', e)}
            label={t('form.email')}
            placeholder={t('form.emailPlaceholder')}
            type={'email'}
          />
        </Col>
        <Col md={12}>
          <CustomPhoneInput
            value={formStates?.phone}
            setter={(e) => handleFormStateUpdate('phone', e)}
            label={t('form.phone')}
            placeholder={t('form.phonePlaceholder')}
          />
        </Col>
        <Col md={12}>
          <Checkbox
            value={formStates?.allowTerms ? t('form.acceptTerms') : ''}
            setValue={(e) => handleFormStateUpdate('allowTerms', e?.length > 0)}
            label={t('form.acceptTerms')}
          />
        </Col>
        <Col md={12}>
          <div style={{ display: 'flex', justifyContent: 'center', scale: '0.75' }}>
            <Captcha 
            
            value={isCaptcha}
            setValue={setIsCaptcha} />
          </div>
        </Col>
        <Col md={12} className="j-center">
          <Button
            className={classes.formBtn}
            variant="secondary"
            type={'submit'}
            disabled={isSubmitting}
            onClick={() => {
              const body = {
                companyName: formStates?.companyName,
                firstName: formStates?.firstName,
                lastName: formStates?.lastName,
                email: formStates?.email,
                phoneNumber: formStates?.phone
              };
              for (let key in body) {
                if (!body[key]) {
                  return toast.error(t('toast.error'));
                }
              }
              if (!validator.isEmail(body?.email)) {
                return toast.error(t('toast.errorEmail'));
              }
              if (
                !validator.isMobilePhone(
                  body?.phoneNumber?.startsWith('+') ? body?.phoneNumber : `+${body?.phoneNumber}`
                )
              ) {
                return toast.error(t('toast.errorPhone'));
              }
              if (!formStates?.allowTerms) {
                return toast.error(t('toast.errorTerms'));
              }
              onSubmit(body);
            }}>
            {isSubmitting ? t('form.btnTextLoading') : t('form.btnText')}
          </Button>
        </Col>
        <Col md={12} className="j-center">
          <p>
            {t('form.alreadyAMember') + ' '}
            <Link to={'/agent-company-login'} className="link">
              {t('form.login')}
            </Link>
          </p>
        </Col>
      </Row>
    </form>
  );
};

RegisterationForm.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired
};
function AgentRegisterationForm() {
  const { t } = useTranslation('advertiseWithUs');
  const { user } = useSelector((state) => state.authReducer);
  const [getPackages, { isLoading, data: packagesData }] = useLazyGetApiQuery();
  const [postApiFunc, { isLoading: isSubmitting }] = usePostApiMutation();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [status, setStatus] = useState('Register Now');
  const [showModal, setShowModal] = useState(false);
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { cmsPages } = useSelector((state) => state.commonReducer);
  const pageData = getSelectedLanguagePage(selectedLanguage, cmsPages, 'advertiseWithUs');

  const handleSubmit = async (body) => {

    const response = await postApiFunc({
      url: `package/purchase/request`,
      method: 'POST',
      data: {
        ...body
      }
    });
    if (response?.data) {
      toast.success(t('toast.successMessage'));
      setShowModal(true);
    }
  };

  const getData = async () => {
    await getPackages({
      url: 'package/all'
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const keepInTouchData = {
    image: KeepInTouchSectionImage,
    list: [
      {
        title: t('section3.items.title1'),
        image: KeepInTouchIcon1
      },
      { title: t('section3.items.title2'), image: KeepInTouchIcon2 },
      { title: t('section3.items.title3'), image: KeepInTouchIcon3 },
      { title: t('section3.items.title4'), image: KeepInTouchIcon4 },
      { title: t('section3.items.title5'), image: KeepInTouchIcon5 }
    ]
  };


  const getStatus = () => {
    const isExpired = user?.packageDetails?.isPackageExpired;

    if (isExpired === true) return setStatus('Renew');
    if (isExpired === false) return setStatus('Purchased');
  };

  useEffect(() => {
    getStatus();
  }, []);

  return (
    <div className={classes.page}>
      <Header containerClass="" />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {/* Hero Section */}
          <HeroSection
            className={classes.heroSection}
            bgImage={imageUrl(pageData?.hero?.bg)}
            heroData={pageData?.hero}
            minHeight="600px"
            center>
            <Row className={classes.heroRow}>
              <Col
                className={classes.heroContentCol}
                lg={{ span: 7, order: 1 }}
                md={{ span: 12, order: 1 }}
                sm={{ span: 12, order: 1 }}
                xs={{ span: 12, order: 1 }}>
                <div className={classes.heroContent}>
                  <div className={classes.logoDiv}>
                    <img
                    alt={pageData?.hero?.image}
                      src={imageUrl(pageData?.hero?.image)}
                      draggable={false}
                    />
                  </div>
                  <h3>
                  
                    {pageData?.hero?.htmlTitle && Parser(pageData?.hero?.htmlTitle)}
                  </h3>
                  <ul>
                    {pageData?.hero?.arr?.map((e, i) => (
                      <li key={`${e?._id}-${i}`}>
                        <MdCheck size={18} color="var(--primary-clr)" />
                        {e}
                      </li>
                    ))}
                  </ul>
                
                </div>
              </Col>
              <Col
                className={classes.formCol}
                lg={{ span: 5, order: 1 }}
                md={{ span: 12, order: 2 }}
                sm={{ span: 12, order: 2 }}
                xs={{ span: 12, order: 2 }}>
                <RegisterationForm
                  t={t}
                  onSubmit={handleSubmit}
                  isSubmitting={isSubmitting}
                  data={{
                    formTitle: pageData?.hero?.formTitle,
                    formDescription: pageData?.hero?.formDescription
                  }}
                />
              </Col>
            </Row>
          </HeroSection>

          {/* Powerfull set of tools */}
          <section className={classes.powerfullSection}>
            <Container className={classes.bgImage}>
              <Row
                style={{
                  backgroundImage: `url(${imageUrl(pageData?.powerfulSetOfTools?.bg)})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'right',
                  backgroundRepeat: 'no-repeat'
                }}>
                <Col lg={6} className={classes.powerfullCol}>
                  <h2>
                  
                    {pageData?.powerfulSetOfTools?.title}
                  </h2>
                  <h5>
                
                    {pageData?.powerfulSetOfTools?.description}
                  </h5>
                  <Row className={classes.powerFullItemRow}>
                    {pageData?.powerfulSetOfTools?.arr?.length > 0 &&
                      pageData?.powerfulSetOfTools?.arr?.map((item, index) => (
                        <Col lg={4} md={6} sm={6} xs={6} key={`${item?._id}-${index}`}>
                          <div className={classes.powerFullItem}>
                            <div className={classes.imgDiv}>
                              <img 
                              
                              alt={item?.image}
                              draggable={false}
                              src={imageUrl(item?.image)} />
                            </div>
                            <p>{item?.title}</p>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Keep In Touch */}
          <section className={classes.keepInTouchSection}>
            <Container>
              <Row>
                <Col md={6}>
                  <div className={classes.img}>
                    <img 
                      
                      alt={keepInTouchData?.image}
                      draggable={false}
                      src={keepInTouchData?.image} />
                  </div>
                </Col>
                <Col md={6} className={classes.keepInTouchCol}>
                  <h3>
                   
                    {pageData?.keepInTouch?.title}
                  </h3>
                  <ul>
                    {pageData?.keepInTouch?.arr?.length > 0 &&
                      pageData?.keepInTouch?.arr?.map((item, index) => (
                        <li key={
                          `${item?._id}-${index}`
                        }>
                          <div className={classes.mainImgDiv}>
                            <div className={classes.imgDiv}>
                              <img 
                                
                              alt={item?.icon}
                              draggable={false}
                              src={imageUrl(item?.icon)} />
                            </div>
                          </div>
                          <p>{item?.description}</p>
                        </li>
                      ))}
                  </ul>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Events Management */}
          <section
            className={classes.eventsManagementSection}
            // style={{ backgroundImage: `url(${imageUrl(pageData?.eventsManagement?.bg)})` }}
          >
            <Container>
              <Row className={classes.eventsRow}>
                <Col md={12}>
                  <h2>
                  

                    {pageData?.eventsManagement?.title}
                  </h2>
                  <h5>
                  
                    {pageData?.eventsManagement?.description}
                  </h5>
                </Col>
                <Col md={12}>
                  <div className={classes.eventsFeaturesDiv}>
                    {pageData?.eventsManagement?.arr?.length > 0 &&
                      pageData?.eventsManagement?.arr?.map((item, index) => {
                        return (
                          <div className={classes.featureMainDiv} key={
                            `${item?._id}-${index}`
                          }>
                            <div className={classes.circleDiv}>
                              <img 
                              
                              alt={item?.image}
                              draggable={false}
                              src={imageUrl(item?.image)} />
                            </div>
                            <p>{item?.title}</p>
                          </div>
                        );
                      })}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

         
          <section className={classes.packagesSection}>
            <Container>
              <Row className={classes.packagesRow}>
                <Col md={12} className={classes.headings}>
                  <h2>
                  

                    {pageData?.ourPackages?.title}
                  </h2>
                  <h5>
                
                    {pageData?.ourPackages?.description}
                  </h5>
                </Col>

                {packagesData?.data?.map((item, index) => {
                  return (
                    <Col xl={3} md={6} key={
                      `${item?._id}-${index}`} id="package" className={classes.packageCol}>
                      <PackageCard
                        selected={selectedPackage?._id == item?._id}
                        status={status}
                       
                        packageType={user?.packageDetails?.packageType || ''}
                        data={item}
                        onRegister={() => {
                          if (status === 'purchased')
                            return toast.error(t('toast.packageAlreadyPurchased'));

                          setSelectedPackage(item);
                          setTimeout(() => {
                            document.getElementById('hero').scrollIntoView({ block: 'end' });
                          }, 1000);
                        }}
                      />
                    </Col>
                  );
                })}
              </Row>
            </Container>
          </section>
        </>
      )}

      <Footer />

      <ThankYouModal show={showModal} handleClose={() => setShowModal(false)} t={t} />
    </div>
  );
}

export default AgentRegisterationForm;


